module.exports = __webpack_public_path__ + "static/media/fedex-express-logo.01b1e245.svg";